import { render, staticRenderFns } from "./OzOverlay.vue?vue&type=template&id=142886e0&scoped=true&"
import script from "./OzOverlay.vue?vue&type=script&lang=ts&"
export * from "./OzOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./OzOverlay.vue?vue&type=style&index=0&id=142886e0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142886e0",
  null
  
)

export default component.exports